export const normalizeFetchOrganizationsResponse = response =>
    Object.keys(response)
        .map(key => ({
            id: Number(key),
            name: response[key],
        }))
        ?.sort((a, b) => a.name.localeCompare(b.name))
